// `lazy()` for a page whose code may fail to load after a deploy: the failure
// becomes a page that says the site was updated, with a reload that asks for
// the scripts again past the cache (lib/chunkReload.ts), never a blank screen.
import { lazy, type ComponentType } from 'react';
import { isChunkLoadError, noteFailedScripts, reloadFresh } from './chunkReload';

export function SiteUpdated() {
  return (
    <div role="alert" className="min-h-dvh grid place-items-center bg-[#0f1012] px-6 text-center text-[#e7e7ea]">
      <div className="flex flex-col items-center gap-4">
        <p className="text-base">The site was updated. Reload the page.</p>
        <button type="button" className="rounded-lg bg-white/10 px-4 py-2 text-sm font-medium hover:bg-white/15" onClick={() => void reloadFresh()}>
          Reload
        </button>
      </div>
    </div>
  );
}

export function lazyPage<P extends object>(load: () => Promise<{ default: ComponentType<P> }>) {
  return lazy(() =>
    load().catch((e: unknown) => {
      if (!isChunkLoadError(e)) throw e;
      noteFailedScripts(e);
      return { default: SiteUpdated as unknown as ComponentType<P> };
    }),
  );
}
